module.exports = __webpack_public_path__ + "static/media/ic_social_facebook_filled.35ae348d.svg";